export const plotConfigError = () => {
    return new Error("Error in the plot configuration definition");
};
export const plotDataMissingValueError = (value) => {
    return new Error(`The following value was missing in the plot dataset: ${value}`);
};
//# sourceMappingURL=errors.js.map